import React from 'react';
import { Section } from './ui/Section';
import { Calendar, BookOpen, ShoppingCart, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCountUp } from '../hooks/useCountUp';
function CounterCard({
  icon: Icon,
  title,
  desc,
  countTarget,
  countSuffix = '',
  index
}: any) {
  const {
    count,
    ref
  } = useCountUp(countTarget || 0, 1500, true);
  return <motion.div initial={{
    opacity: 0,
    y: 50,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    y: 0,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.6,
    type: 'spring'
  }} className="bg-white p-8 rounded-2xl border border-slate-200 shadow-md hover:shadow-xl hover:border-brand-purple/30 transition-all duration-300 group relative overflow-hidden" data-id="element-201">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-purple/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-202" />

      <div className="relative z-10" data-id="element-203">
        <div className="w-14 h-14 bg-brand-brown/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-brown/20 transition-colors group-hover:scale-110 duration-300" data-id="element-204">
          <Icon className={`text-brand-brown ${!countTarget ? 'group-hover:rotate-12 transition-transform' : ''}`} size={28} data-id="element-205" />
        </div>

        <h3 className="font-heading text-2xl text-slate-900 mb-3 flex items-center gap-3 uppercase tracking-wide" data-id="element-206">
          {countTarget && <span className="text-brand-purple font-bold text-3xl tabular-nums" ref={ref} data-id="element-207">
              {count}
              {countSuffix}
            </span>}
          <span data-id="element-208">{title}</span>
        </h3>

        <p className="text-slate-500 text-lg leading-relaxed" data-id="element-209">{desc}</p>
      </div>
    </motion.div>;
}
export default function MechanismSection() {
  return <Section id="mechanism" className="bg-white" data-id="element-210">
      <div className="text-center mb-16" data-id="element-211">
        <h2 className="font-heading text-4xl md:text-6xl text-slate-900 mb-4 uppercase tracking-wide" data-id="element-212">
          El Sistema{' '}
          <span className="text-brand-purple border-b-4 border-brand-purple relative inline-block" data-id="element-213">
            Anti-Decisión
            <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: 0.5,
            duration: 0.8
          }} className="absolute bottom-0 left-0 h-1 bg-brand-brown" data-id="element-214" />
          </span>
        </h2>
        <p className="text-xl md:text-2xl text-slate-500 max-w-3xl mx-auto" data-id="element-215">
          CERO DECISIONES es un sistema simple para que tu semana de comidas
          quede definida en 10 minutos.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-216">
        <CounterCard icon={Calendar} title="Menú Rotativo" desc="12 comidas base + 3 comodines + 2 emergencias. Tu semana no se derrumba por un imprevisto." countTarget={12} index={0} data-id="element-217" />
        <CounterCard icon={BookOpen} title="Lista Maestra" desc="Tu biblioteca personal de cenas. Nunca más «¿qué hago esta semana?»" index={1} data-id="element-218" />
        <CounterCard icon={ShoppingCart} title="Compras por Bloques" desc="Proteína, base, vegetales, sabor. Menos desperdicio. Menos «me faltó X»." countTarget={4} index={2} data-id="element-219" />
        <CounterCard icon={Zap} title="Batch-Planning" desc="Decide cuando tienes batería. Ejecuta en automático cuando no." countTarget={10} countSuffix=" min" index={3} data-id="element-220" />
      </div>
    </Section>;
}